import React from 'react';
import { useTranslation } from 'react-i18next';
import puppyMascot from '../../../assets/images/puppy-mascot.png';
import puppyInterface from '../../../assets/images/puppyknowyou-interface.png';
import { ReactComponent as AstrologyIcon } from '../../../assets/icons/puppy-feature-astrology.svg';
import { ReactComponent as WhimsicalIcon } from '../../../assets/icons/puppy-feature-whimsical.svg';
import { ReactComponent as DiscoveryIcon } from '../../../assets/icons/puppy-feature-discovery.svg';
import './ProductPuppySection.scss';

const BULLETS = [
  {
    Icon: AstrologyIcon,
    textKey: 'home.productPuppy.bullet1',
    colorClass: 'sage',
  },
  {
    Icon: WhimsicalIcon,
    textKey: 'home.productPuppy.bullet2',
    colorClass: 'amber',
  },
  {
    Icon: DiscoveryIcon,
    textKey: 'home.productPuppy.bullet3',
    colorClass: 'rose',
  },
];

function ProductPuppySection() {
  const { t, i18n } = useTranslation();
  const isEn = !i18n.language?.startsWith('zh');

  return (
    <section
      id="puppy"
      className={`product-puppy ${isEn ? 'product-puppy--en' : ''}`}
    >
      <div className="product-puppy__inner">
        <div className="product-puppy__info">
          <div className="product-puppy__intro">
            <img
              src={puppyMascot}
              alt={t('home.productPuppy.mascotAlt')}
              className="product-puppy__mascot"
            />
            <span className="product-puppy__badge">{t('home.productPuppy.badge')}</span>
          </div>

          <h2 className="product-puppy__title">
            <span className="product-puppy__title-main">{t('home.productPuppy.titleMain')}</span>
            {t('home.productPuppy.titleSub') && (
              <>
                {' '}
                <span className="product-puppy__title-sub">{t('home.productPuppy.titleSub')}</span>
              </>
            )}
          </h2>

          <p className="product-puppy__tagline">{t('home.productPuppy.tagline')}</p>
          <p className="product-puppy__desc">{t('home.productPuppy.desc')}</p>

          <div className="product-puppy__quote-card">
            <p className="product-puppy__quote">{t('home.productPuppy.quote')}</p>
          </div>

          <div className="product-puppy__bullets">
            {BULLETS.map((bullet) => (
              <div key={bullet.textKey} className="product-puppy__bullet">
                <div className={`product-puppy__bullet-icon product-puppy__bullet-icon--${bullet.colorClass}`}>
                  <bullet.Icon />
                </div>
                <p className="product-puppy__bullet-text">{t(bullet.textKey)}</p>
              </div>
            ))}
          </div>

          <a href="https://puppyknowyou.com" className="product-puppy__cta">
            {t('home.productPuppy.cta')}
          </a>
        </div>

        <div className="product-puppy__showcase">
          <div className="product-puppy__blur-accent product-puppy__blur-accent--top" />
          <div className="product-puppy__blur-accent product-puppy__blur-accent--bottom" />
          <div className="product-puppy__glass-card">
            <div className="product-puppy__interface-wrap">
              <img
                src={puppyInterface}
                alt={t('home.productPuppy.interfaceAlt')}
                className="product-puppy__interface-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProductPuppySection;
